import update from 'immutability-helper';
import { IAnimalHeavenContext } from './animalHeaven.types';
import { AnimalHeavenActionType } from './animalHeaven.actions.types';
import * as animalHeavenTypes from './animalHeaven.actions.types';
import { initialState } from './animalHeaven.provider';

export const animalHeavenReducer = (
  state: IAnimalHeavenContext,
  action: AnimalHeavenActionType
) => {
  switch (action.type) {
    case animalHeavenTypes.SET_TOKEN: {
      const { token } = action.payload;
      localStorage.setItem('animal_heaven_token', token);
      return update(state, {
        token: { $set: token },
      });
    }

    case animalHeavenTypes.LOGOUT: {
      localStorage.removeItem('animal_heaven_token');
      return update(state, {
        $set: { ...initialState, token: '' },
      });
    }

    case animalHeavenTypes.SET_INITIAL_STATE: {
      const userInformation = action.payload;
      return update(state, {
        user: { $merge: userInformation },
      });
    }

    case animalHeavenTypes.SET_USER_HAS_ADOPTION_CENTER: {
      const { hasAdoptionCenter } = action.payload;
      return update(state, {
        user: { hasAdoptionCenter: { $set: hasAdoptionCenter } },
      });
    }

    case animalHeavenTypes.UPDATE_USER: {
      const userInformation = action.payload;
      return update(state, {
        user: { $merge: userInformation },
      });
    }

    case animalHeavenTypes.SET_PET_TYPES: {
      const { petTypes } = action.payload;
      return update(state, {
        petTypes: { $set: petTypes },
      });
    }

    case animalHeavenTypes.SET_LOADING: {
      const { key, value } = action.payload;
      return update(state, {
        loading: {
          [key]: { $set: value },
        },
      });
    }

    case animalHeavenTypes.SET_GIF_TO_SHOW: {
      const { gifName } = action.payload;
      return update(state, {
        gifToShow: { $set: gifName },
      });
    }

    case animalHeavenTypes.SET_ANIMAL_SIZES: {
      const { animalSizes } = action.payload;
      return update(state, {
        animalSizes: { $set: animalSizes },
      });
    }

    case animalHeavenTypes.ADD_LOCATION_TO_STACK: {
      const { location } = action.payload;
      return update(state, {
        locationStack: { $push: [location] },
      });
    }

    case animalHeavenTypes.SET_PET_CHARACTERISTIC: {
      const { petCharacteristics } = action.payload;
      return update(state, {
        petCharacteristics: { $set: petCharacteristics },
      });
    }

    case animalHeavenTypes.SET_CURRENCY: {
      const { currency } = action.payload;
      return update(state, {
        user: {
          currency: { $set: currency },
        },
      });
    }

    default: {
      return state;
    }
  }
};
